import React from 'react';
import { StarIcon, UnlockIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
import { ShimmerButton } from './ShimmerButton';
interface HeroSectionProps {
  onCtaClick: () => void;
}
export function HeroSection({
  onCtaClick
}: HeroSectionProps) {
  return <section className="py-12 md:py-20 px-5 max-w-4xl mx-auto text-center pt-[10px] pb-[10px]" data-id="element-88">
      <div className="flex flex-col items-center gap-[1px]" data-id="element-89">
        <div className="w-full pt-[10px] pb-[10px] mt-[10px] mb-[10px] space-y-[20px]" data-id="element-90">
          <span className="inline-block bg-zen-beige text-slate-dark text-sm font-semibold px-4 py-1.5 rounded-full" data-id="element-91">
            MÉTODO DE ACTIVACIÓN MENTAL PARA PERROS
          </span>

          <h1 className="text-4xl md:text-6xl font-serif font-bold leading-tight text-[#1D1D1F]" data-id="element-92">
            Detén los destrozos y ladridos de tu perro hoy mismo.
          </h1>

          <p className="text-xl md:text-2xl text-slate-dark/80 font-serif italic font-medium" data-id="element-93">
            — Recupera la paz sin tener que gritarle ni castigar a tu mascota.
          </p>

          <p className="text-lg text-slate-dark/70 font-sans leading-relaxed max-w-2xl mx-auto" data-id="element-94">
            Aplica el método de estimulación mental de 7 minutos que agota a tu
            perro cognitivamente, logrando que se quede en calma total incluso
            cuando queda solo.
          </p>

          <div className="flex justify-center" data-id="element-95">
            <div className="flex items-center gap-3 bg-zen-beige/50 px-4 py-2 rounded-full" data-id="element-96">
              <div className="flex text-yellow-400" data-id="element-97">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-98" />)}
              </div>
              <span className="text-sm font-medium text-slate-dark/70" data-id="element-99">
                +1,200 dueños felices en Chile
              </span>
            </div>
          </div>
        </div>

        <div className="w-full max-w-md mx-auto pt-[0px] pb-[0px] mt-[5px] mb-[5px]" data-id="element-100">
          <div className="w-full mb-8" data-id="element-101">
            <img src="https://cdn.magicpatterns.com/uploads/4moFMmAYzYbEVJZ2g4H4pt/metodosilecio1_v2.webp" alt="Método Silencio - Cero Ladridos y Destrozos" className="w-full h-auto rounded-3xl shadow-2xl block" fetchPriority="high" width={733} height={733} decoding="async" data-id="element-102" />
          </div>

          <FadeInUp delay={0.2} data-id="element-103">
            <ShimmerButton onClick={onCtaClick} className="w-full text-lg mb-6" data-fb-no-track="true" data-id="element-104">
              ¡Sí, quiero un perro tranquilo! - $4.990 🐾
            </ShimmerButton>
          </FadeInUp>

          <FadeInUp delay={0.3} data-id="element-105">
            <div className="flex sm:flex-row gap-4 sm:gap-6 text-sm font-medium text-slate-dark/80 flex-row items-start justify-end" data-id="element-106">
              <div className="flex items-center gap-2" data-id="element-107">
                <div className="bg-pistachio/20 p-1.5 rounded-full" data-id="element-108">
                  <UnlockIcon className="w-4 h-4 text-green-700" data-id="element-109" />
                </div>
                <span data-id="element-110">Pago único</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-111">
                <div className="bg-pistachio/20 p-1.5 rounded-full" data-id="element-112">
                  <DownloadIcon className="w-4 h-4 text-green-700" data-id="element-113" />
                </div>
                <span data-id="element-114">Descarga Inmediata</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-115">
                <div className="bg-pistachio/20 p-1.5 rounded-full" data-id="element-116">
                  <ShieldCheckIcon className="w-4 h-4 text-green-700" data-id="element-117" />
                </div>
                <span data-id="element-118">Compra 100% Protegida</span>
              </div>
            </div>
          </FadeInUp>
        </div>
      </div>
    </section>;
}